import React, { Component } from 'react';

var cur_year = new Date().getFullYear();
var footer_text = "Handcrafted by Stivan Kitchoukov © " + cur_year;

class Footer extends Component {
  render() {
    return (
      <footer className="border-t border-border-subtle bg-bg-base">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 flex flex-col items-center gap-4">
          <div className="flex items-center gap-6 text-ink-secondary">
            <a target="_blank" rel="noopener noreferrer" href="https://stackoverflow.com/users/4651802/stivan" className="hover:text-accent transition-colors" aria-label="Stack Overflow">
              <i className="fa fa-stack-overflow fa-lg fa-fw"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/kitchoukov/" className="hover:text-accent transition-colors" aria-label="LinkedIn">
              <i className="fa fa-linkedin-square fa-lg fa-fw"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.esu.edu" className="hover:text-accent transition-colors" aria-label="ESU">
              <i className="fa fa-graduation-cap fa-lg fa-fw"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/Pr0gramist" className="hover:text-accent transition-colors" aria-label="GitHub">
              <i className="fa fa-github-square fa-lg fa-fw"></i>
            </a>
          </div>
          <p className="text-ink-muted text-xs">{footer_text}</p>
        </div>
      </footer>
    );
  }
}

export default Footer;
